/* MD Flotantes: muestra el botón de volver arriba tras desplazar la página y sube al pulsarlo.
   El desplazamiento de la página vive en window hasta 990px y en .page-wrapper a partir de ahí,
   por eso se escucha el scroll en ambos (excepción justificada a la regla de listeners locales). */
(function () {
  'use strict';

  var instances = [];

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getScrollContainer() {
    return document.querySelector('.page-wrapper');
  }

  function currentScroll(wrapper) {
    var win = window.pageYOffset || document.documentElement.scrollTop || 0;
    var inner = wrapper ? wrapper.scrollTop : 0;
    return Math.max(win, inner);
  }

  function scrollTargetToTop(target, smooth) {
    var behavior = smooth ? 'smooth' : 'instant';
    try {
      target.scrollTo({ top: 0, left: 0, behavior: behavior });
    } catch (err) {
      if (target === window) {
        window.scrollTo(0, 0);
      } else {
        target.scrollTop = 0;
      }
    }
  }

  function initSection(container) {
    if (container.dataset.mdInit) return;
    container.dataset.mdInit = 'true';

    var button = container.querySelector('.md-flotantes__arriba');
    if (!button) return;

    var umbral = parseInt(container.dataset.mdUmbral, 10);
    if (isNaN(umbral) || umbral < 0) umbral = 300;

    var wrapper = getScrollContainer();
    var ticking = false;

    function update() {
      ticking = false;
      var visible = currentScroll(wrapper) > umbral;
      button.classList.toggle('md-flotantes__arriba--visible', visible);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function onClick() {
      var smooth = !reducedMotion();
      scrollTargetToTop(window, smooth);
      if (wrapper) scrollTargetToTop(wrapper, smooth);
      /* El foco vuelve al inicio del documento para que el teclado siga el desplazamiento */
      var main = document.getElementById('MainContent');
      if (main && typeof main.focus === 'function') {
        if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
        main.focus({ preventScroll: true });
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
    button.addEventListener('click', onClick);
    update();

    instances.push({ container: container, wrapper: wrapper, onScroll: onScroll, button: button, onClick: onClick });
  }

  /* Al descargar la sección en el editor se retiran sus listeners de scroll */
  function destroySections(root) {
    for (var i = instances.length - 1; i >= 0; i--) {
      var inst = instances[i];
      if (root === inst.container || root.contains(inst.container)) {
        window.removeEventListener('scroll', inst.onScroll);
        if (inst.wrapper) inst.wrapper.removeEventListener('scroll', inst.onScroll);
        inst.button.removeEventListener('click', inst.onClick);
        instances.splice(i, 1);
      }
    }
  }

  var sections = document.querySelectorAll('.md-flotantes');
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var found = e.target.querySelectorAll('.md-flotantes');
    for (var j = 0; j < found.length; j++) {
      initSection(found[j]);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    destroySections(e.target);
  });
})();
